import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { CrudPanel } from "@/components/library/CrudPanel";
import { HomeownerImport } from "@/components/homeowners/HomeownerImport";
import { HomeownerExport } from "@/components/homeowners/HomeownerExport";

export default function Homeowners() {
  const { user } = useAuth() as any;
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <AppShell title="Homeowners & Projects">
      <CrudPanel key={refreshKey} path="homeowners" title="Homeowners" testid="homeowners" canEdit={!!user} emptyText="Add your first homeowner to start quoting."
        headerActions={<>{user?.role === "admin" && <HomeownerImport onDone={() => setRefreshKey((k) => k + 1)} />}<HomeownerExport /></>}
        fields={[
          { key: "name", label: "Name" },
          { key: "type", label: "Type", type: "radio", options: [{ value: "lead", label: "Lead", cls: "border-amber-600 bg-amber-600 text-white" }, { value: "quoted", label: "Quoted", cls: "border-blue-700 bg-blue-700 text-white" }, { value: "customer", label: "Customer", cls: "border-green-700 bg-green-700 text-white" }] },
          { key: "address", label: "Address" }, { key: "city", label: "City / Region" },
          { key: "email", label: "Email" }, { key: "phone", label: "Phone" }, { key: "notes", label: "Project notes", type: "textarea", hideInTable: true },
        ]} />
    </AppShell>
  );
}
